type KybComplianceEmptyStateVariant = "none" | "search";

type KybComplianceEmptyStateProps = {
  variant: KybComplianceEmptyStateVariant;
  statusLabel?: string;
};

const KybComplianceEmptyState = ({
  variant,
  statusLabel,
}: KybComplianceEmptyStateProps) => {
  const title =
    variant === "search"
      ? "No businesses found"
      : statusLabel
        ? `No ${statusLabel.toLowerCase()} businesses yet`
        : "No businesses yet";

  const subtitle =
    variant === "search"
      ? "Try adjusting your search or filters."
      : "Businesses in this KYB state will appear here once available.";

  const imageSrc =
    variant === "search"
      ? "/images/team-management/no-members-found.svg"
      : "/images/team-management/no-members.svg";

  return (
    <div className="grid min-h-[520px] place-items-center rounded-[16px] border-y border-[#EEF1FB] bg-white px-6 py-12">
      <div className="flex max-w-[360px] flex-col items-center text-center">
        <img
          src={imageSrc}
          alt={title}
          className="h-[180px] w-[180px] object-contain"
        />
        <h3 className="text-[24px] font-[500] text-[#161827]">{title}</h3>
        <p className="text-[16px] leading-7 text-[#6B6F8A]">{subtitle}</p>
      </div>
    </div>
  );
};

export default KybComplianceEmptyState;
